import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Plus, Minus, ArrowLeft, ArrowRight, Check, ShoppingCart, Calculator,
  Trash2, MapPin, ExternalLink, Package, X,
} from 'lucide-react';
import {
  FLOOR_PREP_PRODUCTS,
  EPOXY_PRIMERS,
  HIGH_BUILD_EPOXY,
  FLAKE_PRODUCTS,
  POLYASPARTIC_SEAL,
  HIGH_BUILD_SYSTEMS,
  FLAKE_COVERAGE,
  HIGH_BUILD_COLOUR_CHART,
} from '@/components/proepoxy/productData';
import { calculateOptimalPacks } from '@/components/proepoxy/utils';
import { submitProEpoxyOrder } from '@/components/proepoxy/submitOrder';
import PrioritySelector from '@/components/PrioritySelector';

export default function HighBuildModePicker({ state, priority, setPriority, currentStep, goToStep, highBuildOrderMode, setHighBuildOrderMode, navigate, onExit }) {
  const {
    highBuildAreas, manualOrder,
    showInstallationGuide, setShowInstallationGuide,
    showColourChart, setShowColourChart,
    highBuildSteps,
    addHighBuildArea, removeHighBuildArea, updateHighBuildArea,
    initializeHighBuildProducts,
    calculateHighBuildTotal, getHighBuildItemCount,
    addPrimerItem, updatePrimerItem, removePrimerItem,
    addHighBuildItem, updateHighBuildItem, removeHighBuildItem,
    addFlakeItem, updateFlakeItem, removeFlakeItem,
    updateManualOrder, setManualOrder,
    calculateManualOrderTotal, getManualOrderItemCount,
    updateManualFloorPrepQty,
  } = state;
  return (
              <div className="space-y-6">
                <div className="bg-white rounded-2xl shadow-lg p-6">
                  <h2 className="text-xl font-bold text-[#27292E] mb-2">How do you want to build your order?</h2>
                  <p className="text-gray-600 mb-6">Choose the method that works best for you.</p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Guided Option */}
                    <button
                      onClick={() => setHighBuildOrderMode('guided')}
                      className="p-6 rounded-xl text-left transition-all border-2 border-gray-200 hover:border-[#7A0B7A] hover:bg-[#7A0B7A]/5 group"
                      data-testid="hb-mode-guided"
                    >
                      <div className="w-12 h-12 bg-[#7A0B7A]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#7A0B7A]/20">
                        <Calculator className="w-6 h-6 text-[#7A0B7A]" />
                      </div>
                      <h3 className="font-bold text-[#27292E] text-lg mb-2">Guided Order Builder</h3>
                      <p className="text-sm text-gray-500">
                        Enter your dimensions and our recommendations and calculators will work it out for you
                      </p>
                    </button>

                    {/* Manual Option */}
                    <button
                      onClick={() => setHighBuildOrderMode('manual')}
                      className="p-6 rounded-xl text-left transition-all border-2 border-gray-200 hover:border-[#7A0B7A] hover:bg-[#7A0B7A]/5 group"
                      data-testid="hb-mode-manual"
                    >
                      <div className="w-12 h-12 bg-[#7A0B7A]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#7A0B7A]/20">
                        <Package className="w-6 h-6 text-[#7A0B7A]" />
                      </div>
                      <h3 className="font-bold text-[#27292E] text-lg mb-2">Manually</h3>
                      <p className="text-sm text-gray-500">
                        Simply enter your product requirements
                      </p>
                    </button>
                  </div>
                </div>

                {/* Navigation */}
                <div className="flex gap-4">
                  <Button
                    onClick={() => onExit()}
                    variant="outline"
                    className="flex-1 h-14 text-lg font-medium rounded-xl border-2 border-[#7A0B7A] text-[#7A0B7A] hover:bg-[#7A0B7A]/5"
                  >
                    <ArrowLeft className="w-5 h-5 mr-2" />
                    Back
                  </Button>
                </div>
              </div>
  );
}
